import { css } from 'aphrodite';
import moment from 'moment';
import { styleSheet } from './styles';

interface IProps {
	date: Date;
}

const getCustomRelativeTime = (date: Date): string => {
	const now = moment();
	const targetDate = moment(date);
	const duration = moment.duration(now.diff(targetDate));

	const years = Math.floor(duration.asYears());
	const months = Math.floor(duration.asMonths());
	const days = Math.floor(duration.asDays());
	const hours = Math.floor(duration.asHours());
	const minutes = Math.floor(duration.asMinutes());

	if (years >= 1) {
		return years === 1 ? '1 year ago' : `${years} years ago`;
	}
	if (months >= 1) {
		return months === 1 ? '1 month ago' : `${months} months ago`;
	}
	if (days >= 1) {
		return days === 1 ? '1 day ago' : `${days} days ago`;
	}
	if (hours >= 1) {
		return hours === 1 ? '1 hour ago' : `${hours} hours ago`;
	}
	if (minutes >= 1) {
		return minutes === 1 ? '1 minute ago' : `${minutes} minutes ago`;
	}

	return 'just now';
};

export const ContactTimelineDate = ({ date }: IProps) => {
	return (
		<div className={css(styleSheet.timelineItemContainer)}>
			<div className={css(styleSheet.timelineItemTime)} />
			<div className={css(styleSheet.timelineItemLine)} />
			<div className={css(styleSheet.timelineItemContent, styleSheet.timelineItemDate)}>
				<span className={css(styleSheet.timelineItemDateAgo)}>{getCustomRelativeTime(date)}</span>
				<span className={css(styleSheet.timelineItemDateText)}>
					<time dateTime={moment(date).format('YYYY-MM-DD')} className={css(styleSheet.timelineItemDateText)}>
						{moment(date).format('MM/D/YYYY')}
					</time>
				</span>
			</div>
		</div>
	);
};
